<template>
  <div class="settings">
    <div class="page-title">Settings</div>
    <BaseLayoutCards v-if="!loading">
      <BaseCard>
        <template #header>Your plan</template>
        <BaseForm :values="{ planName: subscribedPlanName }" :submit="updatePlan" #default="{ submittable, loading }">
          <FormulateInput
            name="planName"
            type="select"
            label="Change your plan"
            placeholder="Select a plan"
            :options="
              plans.map(plan => ({
                value: plan.name,
                label: `${plan.title} (${plan.price === 0 ? 'Free' : `$${plan.price} billed ${plan.interval}`})`
              }))
            "
            :outer-class="['input']"
          />
          <BaseButton text="Save" :loading="loading" :theme="submittable ? 'purple' : 'disabled'" />
        </BaseForm>
      </BaseCard>
    </BaseLayoutCards>
    <BaseContentLoader v-else />
  </div>
</template>

<script>
import BaseLayoutCards from '@/components/BaseLayoutCards/BaseLayoutCards'
import BaseCard from '@/components/BaseCard/BaseCard'
import BaseForm from '@/components/BaseForm/BaseForm'
import BaseButton from '@/components/BaseButton/BaseButton'
import BaseContentLoader from '@/components/BaseContentLoader/BaseContentLoader'
import subscriptionService from '@/services/api/services/subscriptionService'
export default {
  components: {
    BaseLayoutCards,
    BaseCard,
    BaseForm,
    BaseButton,
    BaseContentLoader
  },
  async created() {
    this.plans = await subscriptionService.findAllPlans()
    this.loading = false
  },
  data: () => ({
    loading: true,
    plans: []
  }),
  computed: {
    subscribedPlanName() {
      const subscribedPlan = this.plans.find(plan => plan.subscribed === true)
      return subscribedPlan && subscribedPlan.name
    }
  },
  methods: {
    async updatePlan({ planName }) {
      const confirmationUrl = await subscriptionService.create({ name: planName })
      if (confirmationUrl) {
        this.$shopify.redirectToExternalUrl(confirmationUrl)
        await new Promise(() => {})
      } else {
        await this.$store.dispatch('authenticate')
        this.$router.push('/widget')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.settings {
  width: 100%;
  display: grid;
  grid-auto-flow: row;
  grid-gap: var(--spacing-5);
}
.page-title {
  font-size: var(--fs-title);
  font-weight: var(--fw-medium);
}
.text {
  color: var(--color-gray-3);
  line-height: var(--lh-1);
}
.input {
  margin-bottom: var(--spacing-4);
}
</style>
